export default ( type, quantity ) => {
  return {
    quantity,
    type,
  };
};